import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export const getCachedToken = () => {
  const { currentUser } = firebase.auth();

  return currentUser ? currentUser.getIdToken() : null;
};
